module.exports = __webpack_public_path__ + "static/Service-hero-why-restaurants-need-to-evolve-73403817a9fc503232bddb3ad8682ead.jpg";